export const buildUrl = (
  url: string,
  queryParams: { [key: string]: any } = {},
  stringifyArrayParam?: (arr: Array<any>) => string
): string => {
  const newUrl = stripQuery(url);

  return buildUrlRecursive({
    url: newUrl,
    obj: queryParams,
    stringifyArrayParam,
  });
};

export const stripQuery = (url: string) => {
  const indexOfQuestionMark = url.indexOf('?');
  return indexOfQuestionMark === -1 ? url : url.slice(0, indexOfQuestionMark);
};

type BuildUrlRecursiveArgs = {
  url: string;
  obj: { [key: string]: any };
  objName?: string;
  keyConcatSymbol?: string;
  stringifyArrayParam?: (arr: Array<any>) => string;
};

const buildUrlRecursive = ({
  url,
  obj = {},
  objName = '',
  keyConcatSymbol = '.',
  stringifyArrayParam,
}: BuildUrlRecursiveArgs): string => {
  for (const key in obj) {
    url = getUrl(obj, key, url, objName, keyConcatSymbol, stringifyArrayParam);
  }

  return url.replace(/\./g, keyConcatSymbol);
};

const getUrl = (
  obj: { [key: string]: any } = {},
  key: string,
  url: string,
  objName: string,
  keyConcatSymbol: string,
  stringifyArrayParam?: (arr: Array<any>) => string
) => {
  const value = obj[key];
  let urlWithQuery = url;
  if (isObject(value)) {
    urlWithQuery = buildUrlRecursive({
      url: urlWithQuery,
      obj: value,
      objName: key,
    });
  } else if (Array.isArray(value)) {
    const array: any[] = value;
    const stringifiedArray = stringifyArrayParam
      ? stringifyArrayParam(array)
      : array.map(item => encodeURIComponent(item)).toString();
    if (array.length) {
      urlWithQuery += (url.indexOf('?') !== -1 ? '&' : '?') + key + `=` + stringifiedArray;
    }
  } else if (value !== '' && value !== null && value !== undefined) {
    const param = getParamAsUrlString(key, obj, objName, keyConcatSymbol);

    urlWithQuery += (url.indexOf('?') !== -1 ? '&' : '?') + param;
  }

  return urlWithQuery;
};

const isObject = (candidate: object | any): candidate is object =>
  !Array.isArray(candidate) && typeof candidate === 'object' && candidate !== null;

const getParamAsUrlString = (
  paramKey: string,
  obj: { [key: string]: any } = {},
  objName: string,
  keyConcatSymbol: string
) => {
  let key = paramKey;

  if (objName !== '') {
    key = `${objName}${keyConcatSymbol}${key}`;
  }

  const paramValue = encodeURIComponent(obj[paramKey]);

  const param = `${key}=${paramValue}`;

  return param;
};
